import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { useSidebar } from '../../../context/SidebarContext';
import { useBreadcrumb } from '../../../context/BreadcrumbContext';

const SuperAdminDashboard: React.FC = () => {
  const { setActivePage } = useSidebar();
  const { setPath } = useBreadcrumb();

  React.useEffect(() => {
    setActivePage('dashboard');
    setPath([{ title: 'Super Admin Dashboard', path: '/dashboard' }]);
  }, [setActivePage, setPath]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: '#333' }}>
        Super Admin Dashboard
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, color: '#666' }}>
        Welcome to the TalentHub Super Admin control panel.
      </Typography>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Paper sx={{ p: 3, textAlign: 'center', bgcolor: '#e3f2fd' }}>
            <Typography variant="h6">Total Organizations</Typography>
            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>0</Typography>
          </Paper>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Paper sx={{ p: 3, textAlign: 'center', bgcolor: '#e8f5e9' }}>
            <Typography variant="h6">Active Subscriptions</Typography>
            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>0</Typography>
          </Paper>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Paper sx={{ p: 3, textAlign: 'center', bgcolor: '#fff3e0' }}>
            <Typography variant="h6">Total Workers</Typography>
            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>0</Typography>
          </Paper>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <Paper sx={{ p: 3, textAlign: 'center', bgcolor: '#f3e5f5' }}>
            <Typography variant="h6">Total Facilities</Typography>
            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>0</Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SuperAdminDashboard;
